import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { GridComponent, GridDataResult } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { Observable, BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { UrlHelperService } from "./url-helper.service";
import { INotificationService } from "@shared/services/inotification.service";
import { SearchGridComponent } from "@shared/components/grid/search-grid.component";
import { UiColumn } from "@shared/ui/ui-column";
import { LocalTimeConverterPipe } from '@shared/pipes/local-time-converter.pipe';
import { SearchDataAggregateService } from "@shared/services/search-data-aggregate.service";

export abstract class RedeploymnetService extends BehaviorSubject<GridDataResult> {

  public loading: boolean = false;
  public loadData: boolean = false;

  private BASE_URL: string;

  constructor(private http: HttpClient, private urlHelper: UrlHelperService, private notificationService: INotificationService, private localTimeConverter: LocalTimeConverterPipe, private searchAgg: SearchDataAggregateService) {
    var res: GridDataResult = { data: [], total: 0 };
    super(res);

    this.BASE_URL = this.urlHelper.getApiUrl();
  }

  public query(state: State, postData: any, apiController: string, searchGrid?: SearchGridComponent, grid?: GridComponent, columns?: UiColumn[]): void {
    this.fetch(apiController, state, postData, columns).subscribe({
      next: (x) => {
        super.next(x)
        searchGrid?.hideLoadingProgress();
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.statusText
        }

        this.notificationService.show({ title: "Error", description: errorMsg.substring(0, 100), type: "error" });
        if (grid != undefined) {
          grid.loading = false;
        }

        if (searchGrid != undefined) {
          searchGrid.hideLoadingProgress();
        }
      }
    });
  }

  fetch(apiController: string, state: State, postData: any, columns?: UiColumn[]): Observable<GridDataResult> {

    postData['skip'] = state.skip;
    postData['take'] = state.take;

    var url = this.buildUrl(apiController);

    this.loading = true;

    return this.http.post<Array<any>>(url, postData).pipe(
      map(
        (response: any) =>
          <GridDataResult>{
            data: this.convertDates(response['data'], columns),
            total: parseInt(response['total'])
          }
      ),
      tap(() => (this.loading = false))
    );
  }

  convertDates(data: Array<any>, columns?: UiColumn[]): any {
    var dateColumns: UiColumn[] = [];
    if (columns !== undefined) {
      dateColumns = columns.filter(c => c.type == "date");
    }

    for (var i = 0; i < data.length; i++) {
      var rec = data[i];
      for (var x = 0; x < dateColumns.length; x++) {
        var prop = dateColumns[x].field;
        var tempDate = new Date(rec[prop]);
        if (tempDate.getFullYear() > 2005) {
          var utcDate = new Date(Date.UTC(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds()));
          var localDate = new Date(this.localTimeConverter.transform(utcDate));
          rec[prop] = localDate;
        }
      }
    }

    this.searchAgg.compile(data);

    return data;
  }

  buildUrl(apiController: string): string {
    var apiUrl = this.BASE_URL;
    if (!apiUrl.endsWith(apiController)) {
      apiUrl += apiController;
    }

    return apiUrl;
  }

}

@Injectable({
  providedIn: 'root'
})
export class RemoteSearchService extends RedeploymnetService {

  constructor(http: HttpClient, urlHelper: UrlHelperService, notificationService: INotificationService, localTimeConverter: LocalTimeConverterPipe, searchAgg: SearchDataAggregateService) {
    super(http, urlHelper, notificationService, localTimeConverter, searchAgg);
  }

  search(state: State, postData: any, apiController: string, searchGrid: SearchGridComponent) {
    this.query(state, postData, apiController, searchGrid, undefined);
  }

}
